import React, { useState, useEffect } from 'react';
import axios from 'axios';

function Carga() {
  const [planes, setPlanes] = useState([]);
  const [planSeleccionado, setPlanSeleccionado] = useState(null);
  const [pedidos, setPedidos] = useState([]);
  const [cantidades, setCantidades] = useState({});
  const [alertas, setAlertas] = useState({});
  const [mensaje, setMensaje] = useState('');
  const [proveedorAbierto, setProveedorAbierto] = useState(null);

  const token = localStorage.getItem('token');
  const usuario = JSON.parse(localStorage.getItem('usuario'));
  const esEncargado = usuario?.rol === 'encargado';
  const verCantidades = usuario?.rol === 'encargado' || usuario?.rol === 'carga';

  const cargarPlanes = async () => {
    try {
      const res = await axios.get('https://comprasmercadomodelo.online/api/carga/planes', {
        headers: { authorization: token }
      });
      setPlanes(res.data);
    } catch (err) { console.error(err); }
  };

  const cargarPedidos = async (plan_id) => {
    try {
      const res = await axios.get(`https://comprasmercadomodelo.online/api/carga/planes/${plan_id}/pedidos`, {
        headers: { authorization: token }
      });
      setPedidos(res.data);
      setPlanSeleccionado(plan_id);
    } catch (err) { console.error(err); }
  };

  useEffect(() => { cargarPlanes(); }, []);

  const pedidosPorProveedor = pedidos.reduce((acc, pedido) => {
    const key = pedido.proveedor_nombre;
    if (!acc[key]) acc[key] = [];
    acc[key].push(pedido);
    return acc;
  }, {});

  const proveedoresOrdenados = Object.keys(pedidosPorProveedor).sort();

  const getEstadoProveedor = (nombreProveedor) => {
    const items = pedidosPorProveedor[nombreProveedor];
    const todos = items.every(p => p.estado === 'cargado');
    const alguno = items.some(p => p.estado === 'cargado');
    if (todos) return 'completo';
    if (alguno) return 'parcial';
    return 'pendiente';
  };

  const getEstadoLabel = (estado) => {
    const map = {
      verde: '🟢 Verde',
      punto_medio: '🟡 Punto medio',
      maduro: '🟠 Maduro',
      demasiado_maduro: '🔴 Demasiado maduro'
    };
    return map[estado] || null;
  };

  const getEstadoStyle = (estado) => {
    const map = {
      verde: { backgroundColor: '#eafaf1', color: '#27ae60' },
      punto_medio: { backgroundColor: '#fef9e7', color: '#f39c12' },
      maduro: { backgroundColor: '#fef0e7', color: '#e67e22' },
      demasiado_maduro: { backgroundColor: '#fdeaea', color: '#e74c3c' }
    };
    return map[estado] || {};
  };

  const registrarCarga = async (pedidoId) => {
    const cantidad = cantidades[pedidoId];
    if (!cantidad && cantidad !== 0) {
      setAlertas({ ...alertas, [pedidoId]: '⚠️ Ingresá una cantidad' });
      return;
    }
    try {
      const res = await axios.put(
        `https://comprasmercadomodelo.online/api/carga/pedidos/${pedidoId}`,
        { cantidad_cargada: cantidad },
        { headers: { authorization: token } }
      );
      if (res.data.coincide) {
        setAlertas({ ...alertas, [pedidoId]: null });
      } else {
        setAlertas({ ...alertas, [pedidoId]: '⚠️ No coinciden las cantidades, revisá de nuevo' });
      }
      cargarPedidos(planSeleccionado);
    } catch (err) { console.error(err); }
  };

  const cerrarCarga = async () => {
    if (!window.confirm('¿Cerrar la carga? Una vez cerrada no podrás editar más.')) return;
    try {
      await axios.put(
        `https://comprasmercadomodelo.online/api/carga/planes/${planSeleccionado}/cerrar`,
        {},
        { headers: { authorization: token } }
      );
      setMensaje('✅ Carga cerrada correctamente');
      setPlanSeleccionado(null);
      cargarPlanes();
    } catch (err) {
      setMensaje(`❌ ${err.response?.data?.error || 'Error al cerrar'}`);
    }
  };

  const planActual = planes.find(p => p.id === planSeleccionado);
  const cargaCerrada = planActual?.estado === 'cargado';
  const colorEstado = { completo: '#27ae60', parcial: '#f39c12', pendiente: '#e74c3c' };
  const iconoEstado = { completo: '✅', parcial: '🔄', pendiente: '⏳' };

  if (planSeleccionado) {
    return (
      <div style={styles.container}>
        <div style={styles.header}>
          <button style={styles.botonVolver} onClick={() => setPlanSeleccionado(null)}>← Volver</button>
          <h3 style={styles.titulo}>🚛 Carga de Camión</h3>
          {!cargaCerrada ? (
            <button style={styles.botonCerrar} onClick={cerrarCarga}>🔒 Cerrar Carga</button>
          ) : (
            <span style={styles.cerradoBadge}>🔒 Carga Cerrada</span>
          )}
        </div>

        {mensaje && (
          <div style={styles.mensajeBox}>
            {mensaje}
            <button style={styles.cerrarMensaje} onClick={() => setMensaje('')}>✕</button>
          </div>
        )}

        <div style={styles.resumen}>
          <span style={styles.resumenTexto}>
            📦 {proveedoresOrdenados.length} proveedores —
            ✅ {pedidos.filter(p => p.estado === 'cargado').length} / {pedidos.length} productos cargados
          </span>
        </div>

        <div style={styles.listaProveedores}>
          {proveedoresOrdenados.map((nombreProveedor) => {
            const estado = getEstadoProveedor(nombreProveedor);
            const abierto = proveedorAbierto === nombreProveedor;
            const items = pedidosPorProveedor[nombreProveedor];

            return (
              <div key={nombreProveedor} style={styles.tarjetaProveedor}>
                <div style={styles.headerProveedor}
                  onClick={() => setProveedorAbierto(abierto ? null : nombreProveedor)}>
                  <div style={styles.proveedorIzq}>
                    <span style={{ ...styles.estadoIcono, backgroundColor: colorEstado[estado] }}>
                      {iconoEstado[estado]}
                    </span>
                    <span style={styles.nombreProveedor}>{nombreProveedor}</span>
                    <span style={styles.cantidadItems}>({items.length} productos)</span>
                  </div>
                  <span style={styles.flecha}>{abierto ? '▲' : '▼'}</span>
                </div>

                {abierto && (
                  <div style={styles.productosProveedor}>
                    <table style={styles.tableEl}>
                      <thead>
                        <tr style={styles.thead}>
                          <th style={styles.th}>Código</th>
                          <th style={styles.th}>Producto</th>
                          {verCantidades && <th style={styles.th}>Cant. Pedida</th>}
                          <th style={styles.th}>Estado fruta</th>
                          <th style={styles.th}>Vacío</th>
                          {verCantidades && <th style={styles.th}>Cant. Vacío</th>}
                          <th style={styles.th}>Cant. Cargada</th>
                          <th style={styles.th}>Registrar</th>
                        </tr>
                      </thead>
                      <tbody>
                        {items.sort((a, b) => a.producto_nombre.localeCompare(b.producto_nombre)).map((p) => (
                          <React.Fragment key={p.id}>
                            <tr style={{ ...styles.tr, backgroundColor: p.estado === 'cargado' ? '#f0fff4' : 'white' }}>
                              <td style={styles.tdCodigo}>{p.producto_codigo}</td>
                              <td style={styles.tdNombre}>{p.producto_nombre}</td>
                              {verCantidades && <td style={styles.tdCent}>{p.cantidad_pedida}</td>}
                              <td style={styles.td}>
                                {p.estado_mercaderia ? (
                                  <span style={{ ...styles.estadoFrutaBadge, ...getEstadoStyle(p.estado_mercaderia) }}>
                                    {getEstadoLabel(p.estado_mercaderia)}
                                  </span>
                                ) : '-'}
                              </td>
                              <td style={styles.td}>
                                {p.vacio_nombre ? (
                                  <span style={styles.vacioNombre}>{p.vacio_nombre}</span>
                                ) : '-'}
                              </td>
                              {verCantidades && (
  <td style={styles.tdCent}>
    {p.cantidad_pedida > 0 ? (
      <span style={styles.vacioQty}>{p.cantidad_pedida}</span>
    ) : '-'}
  </td>
)}
                              <td style={styles.tdCent}>
                                {p.cantidad_cargada > 0 ? (
                                  <span style={styles.cargadoBadge}>{p.cantidad_cargada}</span>
                                ) : '-'}
                              </td>
                              <td style={styles.td}>
                                {(!cargaCerrada || esEncargado) ? (
                                  <div style={styles.inputGroup}>
                                    <input
                                      style={styles.inputCarga}
                                      type="number"
                                      placeholder="Cant."
                                      value={cantidades[p.id] !== undefined ? cantidades[p.id] : (p.cantidad_cargada > 0 ? p.cantidad_cargada : '')}
                                      onChange={(e) => setCantidades({ ...cantidades, [p.id]: e.target.value })}
                                    />
                                    <button
                                      style={{ ...styles.botonRegistrar, backgroundColor: p.estado === 'cargado' ? '#27ae60' : '#3498db' }}
                                      onClick={() => registrarCarga(p.id)}>
                                      ✓
                                    </button>
                                  </div>
                                ) : (
                                  <span style={styles.bloqueado}>🔒</span>
                                )}
                              </td>
                            </tr>
                            {alertas[p.id] && (
                              <tr>
                                <td colSpan={verCantidades ? 8 : 6} style={styles.alertaItem}>
                                  {alertas[p.id]}
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <h3 style={styles.titulo}>🚛 Carga de Camión</h3>
      <p style={styles.subtitulo}>Seleccioná el plan de compras a cargar</p>
      <div style={styles.lista}>
        {planes.length === 0 ? (
          <p style={styles.sinPlanes}>No hay planes disponibles para cargar</p>
        ) : (
          planes.map((plan) => (
            <div key={plan.id} style={styles.tarjeta} onClick={() => cargarPedidos(plan.id)}>
              <span style={styles.fecha}>📅 {new Date(plan.fecha).toLocaleDateString("es-AR", { timeZone: "UTC" })}</span>
              <span style={styles.comentario}>{plan.comentario || 'Sin comentarios'}</span>
              <span style={{ ...styles.estadoPlan, backgroundColor: plan.estado === 'cargado' ? '#27ae60' : '#3498db' }}>
                {plan.estado}
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

const styles = {
  container: { padding: '20px' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
  titulo: { color: '#2c3e50', fontSize: '22px', margin: 0 },
  subtitulo: { color: '#7f8c8d', marginBottom: '20px' },
  botonVolver: { backgroundColor: '#95a5a6', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '6px', cursor: 'pointer' },
  botonCerrar: { backgroundColor: '#e74c3c', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '6px', cursor: 'pointer' },
  cerradoBadge: { backgroundColor: '#7f8c8d', color: 'white', padding: '10px 20px', borderRadius: '6px', fontSize: '14px' },
  mensajeBox: { backgroundColor: '#ffeaa7', padding: '15px 20px', borderRadius: '8px', marginBottom: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '14px' },
  cerrarMensaje: { background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px' },
  resumen: { backgroundColor: '#eaf2ff', padding: '12px 20px', borderRadius: '8px', marginBottom: '15px' },
  resumenTexto: { fontSize: '14px', color: '#2c3e50' },
  listaProveedores: { display: 'flex', flexDirection: 'column', gap: '10px' },
  tarjetaProveedor: { backgroundColor: 'white', borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', overflow: 'hidden' },
  headerProveedor: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px 20px', cursor: 'pointer' },
  proveedorIzq: { display: 'flex', alignItems: 'center', gap: '12px' },
  estadoIcono: { color: 'white', padding: '4px 10px', borderRadius: '20px', fontSize: '12px' },
  nombreProveedor: { fontWeight: 'bold', color: '#2c3e50', fontSize: '15px' },
  cantidadItems: { color: '#95a5a6', fontSize: '13px' },
  flecha: { color: '#95a5a6', fontSize: '12px' },
  productosProveedor: { borderTop: '1px solid #ecf0f1', overflowX: 'auto' },
  tableEl: { width: '100%', borderCollapse: 'collapse' },
  thead: { backgroundColor: '#f8f9fa' },
  th: { color: '#7f8c8d', padding: '10px 12px', textAlign: 'left', fontSize: '12px', borderBottom: '1px solid #ecf0f1', whiteSpace: 'nowrap' },
  tr: { borderBottom: '1px solid #ecf0f1' },
  td: { padding: '10px 12px', fontSize: '13px', color: '#2c3e50' },
  tdCodigo: { padding: '10px 12px', fontSize: '12px', color: '#3498db', fontWeight: 'bold', whiteSpace: 'nowrap' },
  tdNombre: { padding: '10px 12px', fontSize: '13px', color: '#2c3e50', minWidth: '180px' },
  tdCent: { padding: '10px 12px', fontSize: '13px', color: '#2c3e50', textAlign: 'center' },
  estadoFrutaBadge: { padding: '3px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: '500' },
  vacioNombre: { backgroundColor: '#eaf2ff', color: '#2980b9', padding: '2px 8px', borderRadius: '4px', fontSize: '12px' },
  vacioQty: { backgroundColor: '#fef9e7', color: '#f39c12', padding: '2px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: 'bold' },
  cargadoBadge: { backgroundColor: '#eafaf1', color: '#27ae60', padding: '2px 8px', borderRadius: '4px', fontSize: '12px', border: '1px solid #27ae60' },
  inputGroup: { display: 'flex', gap: '8px', alignItems: 'center' },
  inputCarga: { width: '70px', padding: '6px', borderRadius: '4px', border: '1px solid #ddd', fontSize: '14px' },
  botonRegistrar: { color: 'white', border: 'none', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer', fontSize: '16px' },
  bloqueado: { color: '#95a5a6', fontSize: '16px' },
  alertaItem: { backgroundColor: '#ffeaa7', padding: '8px 12px', color: '#e67e22', fontWeight: 'bold', fontSize: '13px' },
  lista: { display: 'flex', flexDirection: 'column', gap: '15px' },
  sinPlanes: { textAlign: 'center', color: '#95a5a6', padding: '40px' },
  tarjeta: { backgroundColor: 'white', padding: '20px', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  fecha: { fontSize: '16px', fontWeight: 'bold', color: '#2c3e50' },
  comentario: { color: '#7f8c8d' },
  estadoPlan: { color: 'white', padding: '4px 12px', borderRadius: '20px', fontSize: '12px' }
};

export default Carga;